// @flow
import React from 'react'
import DashboardTitle from './DashboardTitle'
import DashboardHeaderIcons from './DashboardHeaderIcons'
import BackToRepoListLink from './BackToRepoListLink'
import RefreshAnalysisButton from '../../../containers/shared/Header/RefreshAnalysisButtonContainer'
import AnalysisStatus from '../../../containers/shared/Header/AnalysisStatusContainer'
import Badge from '../../shared/BadgeWithLabel'

type Props = {
  model: Object,
  currentAccount?: Object,
  title: string,
  gpa: string,
  favourite: boolean,
  'private': boolean,
  last_analysed_commit_url: string,
  last_analysed_commit_hash: string,
  default_branch_name: string,
  dashboardPath: string,
}

export default class DashboardHeaderTop extends React.Component<Props> {
  render () {
    const detailsStyle = {
      padding: '0px',
      borderBottom: '2px solid #d3d3d3',
      display: 'flex',
      alignItems: 'center',
      width: '100%'
    }

    return (
      <div style={detailsStyle}>
        <BackToRepoListLink url={this.props.dashboardPath} />
        <Badge value={this.props.gpa} label='GPA' />
        <DashboardTitle title={this.props.title} />
        <DashboardHeaderIcons
          favourite={this.props.favourite}
          private={this.props.private}
        />
        <div style={{marginLeft: 'auto', textAlign: 'right'}}>
          <a href={this.props.last_analysed_commit_url}>
            {this.props.last_analysed_commit_hash}@
            {this.props.default_branch_name}
          </a>
          <div style={{display: 'flex', alignItems: 'top'}}>
            <AnalysisStatus />
            <RefreshAnalysisButton
              model={this.props.model}
              currentAccount={this.props.currentAccount}
            />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/project_dashboard/Header/DashboardHeaderTop.js